import {FinancingCellCoordinates} from '../types/FinancingCellCoordinates';
import {getFinancingCellKey} from './getFinancingCellKey';

export function toggleFinancingCellSelection(
  selection: FinancingCellCoordinates[],
  coordinates: FinancingCellCoordinates
) {
  const coordinateKey = getFinancingCellKey(coordinates);

  return selection.some((item) => getFinancingCellKey(item) === coordinateKey)
    ? selection.filter((item) => getFinancingCellKey(item) !== coordinateKey)
    : [...selection, coordinates];
}
